import { FunctionComponent } from "react";
import { useHistory } from "react-router-dom";

import { PRIMARY_COLOR } from "../../utils";

export const BackLink: FunctionComponent = () => {
    const history = useHistory();

    return (
        <a
            href="#"
            onClick={() => history.goBack()}
            style={{ color: PRIMARY_COLOR }}
        >
            Zpět
        </a>
    );
};
